angular.module('aprima-core-ui').directive('apDateFormatter', ['LanguageFactory', '$log', '_',
    function(LanguageFactory, $log, _){
        'use strict';

        var lang = LanguageFactory.getLang();

        var formatter = function(date, format){
            var formatted,
                dateArray;
            var langCode = (!lang || lang.code === '' ) ? 'en_us' : lang.code.toLowerCase();
            var isEnglish = (langCode === 'en_us');

            if(date === undefined){
                return '';
            }

            //when using input[type="date"], dates can have quotes added like: '"01/01/2000"'. This strips those quotes out since quotes shouldnt be in a date anyway.
            if(_.isString(date)) {
                date = date.replace(/"/igm, '');
            }

            moment.locale(langCode);
            var thisMoment;
            if(moment(date, 'MM/DD/YYYY').isValid()) {
                thisMoment = moment(new Date(date));
            }
            else {
                thisMoment = moment(date);
            }

            switch (format) {

                case 'date-time':
                    formatted = thisMoment.format('L LT');
                    break;
                case 'short-date':
                    if (isEnglish) {
                        formatted = thisMoment.format('M/D/YY');
                    }
                    else {
                        formatted = thisMoment.format('D/M/YY');
                    }
                    break;
                case 'date':
                    formatted = thisMoment.format('L');
                    break;
                case 'time':
                    formatted = thisMoment.format('LT');
                    break;
                case 'short-time':
                    if (isEnglish) {
                        formatted = thisMoment.format('h:mm');
                    } else {
                        formatted = thisMoment.format('H:mm');
                    }
                    break;
                case 'long-date':
                    formatted = thisMoment.format('LL');
                    break;
                case 'long-abb-date':
                    formatted = thisMoment.format('ll');
                    break;
                case 'short-day':
                    if (isEnglish) {
                        dateArray = thisMoment.format('llll').split(',');
                        formatted = dateArray[0];
                    } else {
                        dateArray = thisMoment.format('LLLL').split(',');
                        formatted = dateArray[0];
                    }
                    break;
                case 'long-day':
                    dateArray = thisMoment.format('LLLL').split(',');
                    formatted = dateArray[0];
                    break;
                case 'monthname-dayofmonth' :
                    if (isEnglish) {
                        dateArray = thisMoment.format('lll').split(',');
                        formatted = dateArray[0];
                    } else {
                        dateArray = thisMoment.format('LLL').split(',');
                        formatted = dateArray[0];
                    }
                    break;
                case 'full-date':
                    formatted = thisMoment.format('dddd, MMMM DD, YYYY');
                    break;
                case 'abb-full-date':
                    formatted = thisMoment.format('ddd MMM DD, YYYY');
                    break;
                default:
                    formatted = thisMoment.format('L LT');
                    break;
            }

            return formatted;
        };

        return {
            restrict: 'AEC',
            scope: {
                date: '@',
                jsdate: '=',
                format: '@'
            },
            link: function (scope, element) {
                var removeWatch = scope.$watchCollection('[date, format, default, jsdate]', function (newval, oldval) {
                    var output;
                    if (newval !== oldval || output === undefined) {
                        var date = newval[3] || newval[0];
                        var format = newval[1];

                        if (date !== '') {
                            output = formatter(date, format);
                            if (output === 'Invalid date') {
                                $log.info('apDateFormatter: error converting ' + date);
                                return;
                            }
                            element.html(output);
                        }
                    }
                });

                scope.$on('$destroy', function(){
                    removeWatch();
                });
            }
        };

    }]);
